module.exports = __webpack_public_path__ + "static/media/port.f5d250c6.gif";